import { createContext, useContext, useState, useEffect } from "react";
import it from "./it";
import en from "./en";

const dictionaries = { it, en };
const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("az-lang") || "it");

  useEffect(() => {
    localStorage.setItem("az-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = { lang, setLang, t: dictionaries[lang] };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
